import { useTheme, Box, Divider, Typography } from '@mui/material';
import Moment from 'moment';
import _ from 'lodash';
import SimpleTooltip from '../../SimpleTooltip';

export const BORIndicatorCell = ({ children, policy = {} }: any) => {
  const theme = useTheme();

  const color = policy.isBOR
    ? theme.config.colors.cowbellBlue
    : theme.palette.error.light;

  if (!policy.brokerOfRecord) {
    return children;
  }

  return (
    <SimpleTooltip title={<BORIndicatorTooltip policy={policy} />}>
      <Box style={{ color, fontWeight: 'bold' }}>{children}</Box>
    </SimpleTooltip>
  );
};

const BORIndicatorTooltip = ({ policy = {} }) => {
  const text = {
    // @ts-expect-error TS(2339): Property 'isBOR' does not exist on type '{}'.
    title: policy.isBOR ? 'BOR Processed' : 'BOR in Process',
    originalAgencyLabel: 'Old Agency:',
    newAgencyLabel: 'New Agency:',
    originalAgentLabel: 'Old Agent:',
    newAgentLabel: 'New Agent:',
    originalEmailLabel: 'Old Agent Email:',
    newEmailLabel: 'New Agent Email:',
  };

  const {
    // @ts-expect-error TS(2339): Property 'agencyName' does not exist on type '{}'.
    agencyName: originalAgencyName,
    // @ts-expect-error TS(2339): Property 'agentFirstName' does not exist on type '{}'.
    agentFirstName: originalAgentFirstName,
    // @ts-expect-error TS(2339): Property 'agentLastName' does not exist on type '{}'.
    agentLastName: originalAgentLastName,
    // @ts-expect-error TS(2339): Property 'agentEmail' does not exist on type '{}'.
    agentEmail: originalAgentEmail,
  } = policy;
  const {
    // @ts-expect-error TS(2339): Property 'agencyName' does not exist on type '{}'.
    agencyName: newAgencyName,
    // @ts-expect-error TS(2339): Property 'agentFirstName' does not exist on type '{}'.
    agentFirstName: newAgentFirstName,
    // @ts-expect-error TS(2339): Property 'agentLastName' does not exist on type '{}'.
    agentLastName: newAgentLastName,
    // @ts-expect-error TS(2339): Property 'agentEmail' does not exist on type '{}'.
    agentEmail: newAgentEmail,
    // @ts-expect-error TS(2339): Property 'created' does not exist on type '{}'.
    created: receivedOnDate,
  } = _.get(policy, 'brokerOfRecord', {});

  const receivedOnDateString = receivedOnDate
    ? Moment.utc(receivedOnDate).format('M/D/YYYY hh:mm A')
    : '-';

  const originalAgentName = `${originalAgentFirstName || ''} ${originalAgentLastName || ''}`.trim() || '-';
  const newAgentName = `${newAgentFirstName || ''} ${newAgentLastName || ''}`.trim() || '-';

  return (
    <Box>
      <h3 style={{ textAlign: 'center' }}>{text.title}</h3>
      <Divider style={{ margin: '1rem' }} />
      <LineItem title={text.originalAgencyLabel} content={originalAgencyName} />
      <LineItem title={text.originalAgentLabel} content={originalAgentName} />
      <LineItem title={text.originalEmailLabel} content={originalAgentEmail || '-'} />
      <Divider style={{ margin: '1rem' }} />
      <LineItem title={text.newAgencyLabel} content={newAgencyName} />
      <LineItem title={text.newAgentLabel} content={newAgentName} />
      <LineItem title={text.newEmailLabel} content={newAgentEmail || '-'} />
      <Divider style={{ margin: '1rem' }} />
      <LineItem title="Received On:" content={receivedOnDateString} />
    </Box>
  );
};

const LineItem = ({ title, content }: any) => (
  <Box display="flex" justifyContent="space-between">
    <Typography variant="body2" style={{ width: '12rem' }}>
      {title}
    </Typography>
    <Typography
      variant="body2"
      style={{
        width: '15rem',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {content}
    </Typography>
  </Box>
);
